import React from 'react';
import { Input } from './input';

const FastInput = ({ value, onValueChange, ...props }) => {
    const [localValue, setLocalValue] = React.useState(value);

    React.useEffect(() => {
        setLocalValue(value);
    }, [value]);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            if (localValue !== value) {
                onValueChange(localValue);
            }
        }, 500); // 500ms debounce

        return () => {
            clearTimeout(handler);
        };
    }, [localValue, value, onValueChange]);

    return (
        <Input
            {...props}
            value={localValue}
            onChange={e => setLocalValue(e.target.value)}
        />
    );
};

export default FastInput;
